<template>
  <vs-popup
    title="Verifikasi - OTP"
    :active.sync="localData"
    @vs-close="closeForm">
    <div class="flex flex-col overflow-hidden">
      <p>
        Kode OTP sudah dikirimkan ke
        <span>
          <b>{{ data.email }}</b
          >.
        </span>
      </p>
      <div class="mt-5">
        <!-- <label for="otp">Kode OTP</label> -->
        <v-otp-input
          ref="otpInput"
          class="flex justify-between"
          input-classes="otp-input"
          :conditionalClass="['one', 'two', 'three', 'four']"
          separator=""
          inputmode="numeric"
          :num-inputs="4"
          @on-change="handleOnChange"
          :should-auto-focus="true"
          :should-focus-order="true"
          :placeholder="['*', '*', '*', '*']" />
      </div>
      <div class="mt-5 flex flex-row w-full" style="gap: 10px">
        <vs-button
          color="danger"
          type="border"
          class="w-1/2 font-bold"
          @click="sendOtp"
          :disabled="timeCountDown > 0"
          >Kirim Lagi <span class="ml-2"> ({{ countDownFormat }}) </span>
        </vs-button>
        <vs-button
          color="danger"
          class="w-1/2 font-bold"
          @click="handleSubmit"
          :disabled="otpInput.length < 4"
          >Submit</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../repository/index'
import * as moment from 'moment'

export default {
  props: {
    openModal: Boolean,
    data: Object,
  },
  data() {
    return {
      baseMap: 'openstreetmap',
      otpInput: '',
      timeCountDown: 60,
      timeInterval: null,
    }
  },
  computed: {
    localData: {
      get() {
        // set time countdown to decrease every second when modal is open
        if (this.openModal) {
          if (!this.timeInterval) {
            this.timeInterval = setInterval(() => {
              this.timeCountDown--
              if (this.timeCountDown === 0) {
                clearInterval(this.timeInterval)
              }
            }, 1000)
          }
        } else {
          clearInterval(this.timeInterval)
          this.timeCountDown = 60
          this.timeInterval = null
        }

        return this.openModal
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal', false)
        }
      },
    },
    countDownFormat() {
      const res = moment.utc(this.timeCountDown * 1000).format('m:ss')

      return res
    },
  },
  // for testing pupose
  // watch: {
  //   selectedDuration(val) {
  //
  //   },
  // },
  watch: {
    // otpInput(val) {
    //
    //   // if (val.length === 4) {
    //   //   this.handleSubmit()
    //   // }
    // },
  },
  methods: {
    handleOnChange(val) {
      this.otpInput = val
    },
    sendOtp() {
      this.timeCountDown = 60
      const interval = setInterval(() => {
        this.timeCountDown--
        if (this.timeCountDown === 0) {
          clearInterval(interval)
        }
      }, 1000)

      const payload = {
        email: this.data.email,
      }
      this.$store.dispatch('auth/sendOtp', payload)
    },
    closeForm() {
      this.$emit('closeModal', false)
    },
    handleSubmit() {
      const payload = {
        email: this.data.email,
        password: this.data.password,
        otp: this.otpInput,
        notify: (x) => {
          this.$vs.notify({
            title: 'Error',
            text: 'Kode OTP yang Anda masukkan salah. Silahkan coba lagi.',
            color: 'danger',
          })
        },
        clearOtp: (x) => {
          this.otpInput = ''
          this.$refs.otpInput.clearInput()
        },
      }

      this.$store.dispatch('auth/checkOtp', payload)
    },
  },
}
</script>

<style lang="css">
.vs-popup {
  width: 450px !important;
}
.otp-input {
  width: 80px;
  height: 80px;
  padding: 5px;
  /* margin: 0 10px; */
  font-size: 40px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
